import RequestTypeCell from './RequestTypeCell';

export default RequestTypeCell;
